import React from 'react'

import { Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { IPostElementProps } from '../../../../types/types'
import Image from './Image'

const LinkPost: React.FC<IPostElementProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      width: 'auto',
      display: 'block',
      borderStyle: props.value.imageUrl ? 'solid' : 'initial',
      borderRadius: 2,
      borderWidth: 'thin',
      margin: '13px 0',
    },
    link: {
      display: 'block',
      color: '#646464 !important',
      textDecoration: 'none !important',
      '&link': {
        color: ' #000 !important',
        textDecoration: 'none !important',
      },
      '&hover': {
        color: ' #000 !important',
        textDecoration: 'none !important',
      },
      '&visited': {
        color: ' #000 !important',
        textDecoration: 'none !important',
      },
    },
    textBox: {
      margin: theme.spacing(1, 2),
    },
    linkHeadline: {
      fontFamily: 'Georgia',
      fontSize: '18px',
    },
    linkText: {
      fontFamily: 'Georgia',
    },
  }))

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <a className={classes.link} href={props.value.url} rel='noreferrer' target='_blank'>
        <Image data={props.value.imageUrl} style={{ height: '100%' }} />

        <div className={classes.textBox}>
          <Typography className={classes.linkHeadline}>{props.value.caption}</Typography>
          <Typography className={classes.linkText}>{props.value.description}</Typography>
        </div>
      </a>
    </div>
  )
}

export default LinkPost
